/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmTeasableCommon_CmArticleImpl_Fragment, CmTeasableCommon_CmAudioImpl_Fragment, CmTeasableCommon_CmChannelImpl_Fragment, CmTeasableCommon_CmCollectionImpl_Fragment, CmTeasableCommon_CmDownloadImpl_Fragment, CmTeasableCommon_CmDynamicListImpl_Fragment, CmTeasableCommon_CmExternalLinkImpl_Fragment, CmTeasableCommon_CmGalleryImpl_Fragment, CmTeasableCommon_CmhtmlImpl_Fragment, CmTeasableCommon_CmImageMapImpl_Fragment, CmTeasableCommon_CmInteractiveImpl_Fragment, CmTeasableCommon_CmLocTaxonomyImpl_Fragment, CmTeasableCommon_CmMediaImpl_Fragment, CmTeasableCommon_CmNavigationImpl_Fragment, CmTeasableCommon_CmPersonImpl_Fragment, CmTeasableCommon_CmPictureImpl_Fragment, CmTeasableCommon_CmPlaceholderImpl_Fragment, CmTeasableCommon_CmProductImpl_Fragment, CmTeasableCommon_CmQueryListImpl_Fragment, CmTeasableCommon_CmSelectionRulesImpl_Fragment, CmTeasableCommon_CmSpinnerImpl_Fragment, CmTeasableCommon_CmTaxonomyImpl_Fragment, CmTeasableCommon_CmTeasableImpl_Fragment, CmTeasableCommon_CmTeaserImpl_Fragment, CmTeasableCommon_CmVideoImpl_Fragment, CmTeasableCommon_CmVisualImpl_Fragment, CmTeasableCommon_FormEditorImpl_Fragment, CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment, CmTeasableCommon_SosAuthorImpl_Fragment, CmTeasableCommon_SosChartImpl_Fragment, CmTeasableCommon_SosContactImpl_Fragment, CmTeasableCommon_SosDonationCardImpl_Fragment, CmTeasableCommon_SosDonationCertificateImpl_Fragment, CmTeasableCommon_SosDonationFormImpl_Fragment, CmTeasableCommon_SosDonationProductImpl_Fragment, CmTeasableCommon_SosDonationProgressImpl_Fragment, CmTeasableCommon_SosDonationToolImpl_Fragment, CmTeasableCommon_SosEventImpl_Fragment, CmTeasableCommon_SosFilterTeaserImpl_Fragment, CmTeasableCommon_SosInternalLinkImpl_Fragment, CmTeasableCommon_SosJobTeaserImpl_Fragment, CmTeasableCommon_SosLocationImpl_Fragment, CmTeasableCommon_SosNewsImpl_Fragment, CmTeasableCommon_SosNotificationImpl_Fragment, CmTeasableCommon_SosOfferImpl_Fragment, CmTeasableCommon_SosOrderFormImpl_Fragment, CmTeasableCommon_SosOrganisationImpl_Fragment, CmTeasableCommon_SosOverlayImpl_Fragment, CmTeasableCommon_SosPressreleaseImpl_Fragment, CmTeasableCommon_SosPublicationImpl_Fragment, CmTeasableCommon_SosRedirectPageImpl_Fragment, CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment, CmTeasableCommon_SosSpecialTopicImpl_Fragment, CmTeasableCommon_SosTeaserImpl_Fragment, CmTeasableCommon_SosTextfragmentImpl_Fragment, CmTeasableCommon_SosTooltipImpl_Fragment, CmTeasableCommon_SosWimmelbildImpl_Fragment, CmTeasableCommon_ViewTypeHeroCollection_Fragment } from './CMTeasableCommon.fragment';
import { CmTaxonomy_CmLocTaxonomyImpl_Fragment, CmTaxonomy_CmTaxonomyImpl_Fragment, CmTaxonomy_SosLocationImpl_Fragment } from './CMTaxonomy.fragment';
import { CmTeasableTeaserTarget_CmArticleImpl_Fragment, CmTeasableTeaserTarget_CmAudioImpl_Fragment, CmTeasableTeaserTarget_CmChannelImpl_Fragment, CmTeasableTeaserTarget_CmCollectionImpl_Fragment, CmTeasableTeaserTarget_CmDownloadImpl_Fragment, CmTeasableTeaserTarget_CmDynamicListImpl_Fragment, CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment, CmTeasableTeaserTarget_CmGalleryImpl_Fragment, CmTeasableTeaserTarget_CmhtmlImpl_Fragment, CmTeasableTeaserTarget_CmImageMapImpl_Fragment, CmTeasableTeaserTarget_CmInteractiveImpl_Fragment, CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment, CmTeasableTeaserTarget_CmMediaImpl_Fragment, CmTeasableTeaserTarget_CmNavigationImpl_Fragment, CmTeasableTeaserTarget_CmPersonImpl_Fragment, CmTeasableTeaserTarget_CmPictureImpl_Fragment, CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment, CmTeasableTeaserTarget_CmProductImpl_Fragment, CmTeasableTeaserTarget_CmQueryListImpl_Fragment, CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment, CmTeasableTeaserTarget_CmSpinnerImpl_Fragment, CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment, CmTeasableTeaserTarget_CmTeasableImpl_Fragment, CmTeasableTeaserTarget_CmTeaserImpl_Fragment, CmTeasableTeaserTarget_CmVideoImpl_Fragment, CmTeasableTeaserTarget_CmVisualImpl_Fragment, CmTeasableTeaserTarget_FormEditorImpl_Fragment, CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment, CmTeasableTeaserTarget_SosAuthorImpl_Fragment, CmTeasableTeaserTarget_SosChartImpl_Fragment, CmTeasableTeaserTarget_SosContactImpl_Fragment, CmTeasableTeaserTarget_SosDonationCardImpl_Fragment, CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment, CmTeasableTeaserTarget_SosDonationFormImpl_Fragment, CmTeasableTeaserTarget_SosDonationProductImpl_Fragment, CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment, CmTeasableTeaserTarget_SosDonationToolImpl_Fragment, CmTeasableTeaserTarget_SosEventImpl_Fragment, CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment, CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment, CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment, CmTeasableTeaserTarget_SosLocationImpl_Fragment, CmTeasableTeaserTarget_SosNewsImpl_Fragment, CmTeasableTeaserTarget_SosNotificationImpl_Fragment, CmTeasableTeaserTarget_SosOfferImpl_Fragment, CmTeasableTeaserTarget_SosOrderFormImpl_Fragment, CmTeasableTeaserTarget_SosOrganisationImpl_Fragment, CmTeasableTeaserTarget_SosOverlayImpl_Fragment, CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment, CmTeasableTeaserTarget_SosPublicationImpl_Fragment, CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment, CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment, CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment, CmTeasableTeaserTarget_SosTeaserImpl_Fragment, CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment, CmTeasableTeaserTarget_SosTooltipImpl_Fragment, CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment, CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment } from './CMTeasebleTeaserTarget.fragment';
import { SosTextfragmentFragment } from './SOSTextfragment.fragment';
import { SosDonationCertificateFragment } from './SOSDonationCertificate.fragment';
import { CmLinkable_CmArticleImpl_Fragment, CmLinkable_CmAudioImpl_Fragment, CmLinkable_CmChannelImpl_Fragment, CmLinkable_CmCollectionImpl_Fragment, CmLinkable_CmDownloadImpl_Fragment, CmLinkable_CmDynamicListImpl_Fragment, CmLinkable_CmExternalLinkImpl_Fragment, CmLinkable_CmGalleryImpl_Fragment, CmLinkable_CmhtmlImpl_Fragment, CmLinkable_CmImageMapImpl_Fragment, CmLinkable_CmInteractiveImpl_Fragment, CmLinkable_CmLinkableImpl_Fragment, CmLinkable_CmLocTaxonomyImpl_Fragment, CmLinkable_CmMediaImpl_Fragment, CmLinkable_CmNavigationImpl_Fragment, CmLinkable_CmPersonImpl_Fragment, CmLinkable_CmPictureImpl_Fragment, CmLinkable_CmPlaceholderImpl_Fragment, CmLinkable_CmProductImpl_Fragment, CmLinkable_CmQueryListImpl_Fragment, CmLinkable_CmSelectionRulesImpl_Fragment, CmLinkable_CmSpinnerImpl_Fragment, CmLinkable_CmTaxonomyImpl_Fragment, CmLinkable_CmTeasableImpl_Fragment, CmLinkable_CmTeaserImpl_Fragment, CmLinkable_CmVideoImpl_Fragment, CmLinkable_CmVisualImpl_Fragment, CmLinkable_FormEditorImpl_Fragment, CmLinkable_SosAmountIncreaseFormImpl_Fragment, CmLinkable_SosAuthorImpl_Fragment, CmLinkable_SosChartImpl_Fragment, CmLinkable_SosContactImpl_Fragment, CmLinkable_SosDonationCardImpl_Fragment, CmLinkable_SosDonationCertificateImpl_Fragment, CmLinkable_SosDonationFormImpl_Fragment, CmLinkable_SosDonationProductImpl_Fragment, CmLinkable_SosDonationProgressImpl_Fragment, CmLinkable_SosDonationToolImpl_Fragment, CmLinkable_SosEventImpl_Fragment, CmLinkable_SosFilterTeaserImpl_Fragment, CmLinkable_SosInternalLinkImpl_Fragment, CmLinkable_SosJobTeaserImpl_Fragment, CmLinkable_SosLocationImpl_Fragment, CmLinkable_SosNewsImpl_Fragment, CmLinkable_SosNotificationImpl_Fragment, CmLinkable_SosOfferImpl_Fragment, CmLinkable_SosOrderFormImpl_Fragment, CmLinkable_SosOrganisationImpl_Fragment, CmLinkable_SosOverlayImpl_Fragment, CmLinkable_SosPressreleaseImpl_Fragment, CmLinkable_SosPublicationImpl_Fragment, CmLinkable_SosRedirectPageImpl_Fragment, CmLinkable_SosSpecialTopicCategoryImpl_Fragment, CmLinkable_SosSpecialTopicImpl_Fragment, CmLinkable_SosTeaserImpl_Fragment, CmLinkable_SosTextfragmentImpl_Fragment, CmLinkable_SosTooltipImpl_Fragment, CmLinkable_SosWimmelbildImpl_Fragment, CmLinkable_ViewTypeHeroCollection_Fragment } from './CMLinkable.fragment';
import { gql } from '@apollo/client';
import { CmTeasableCommonFragmentDoc } from './CMTeasableCommon.fragment';
import { CmTaxonomyFragmentDoc } from './CMTaxonomy.fragment';
import { CmTeasableTeaserTargetFragmentDoc } from './CMTeasebleTeaserTarget.fragment';
import { SosTextfragmentFragmentDoc } from './SOSTextfragment.fragment';
import { SosDonationCertificateFragmentDoc } from './SOSDonationCertificate.fragment';
import { CmLinkableFragmentDoc } from './CMLinkable.fragment';
export type SosDonationProductFragment = (
  { __typename?: 'SOSDonationProductImpl', price?: string | null, articleNumber?: string | null, unit?: string | null, recommendation?: boolean | null, new?: boolean | null, details?: { __typename?: 'RichText', textAsTree?: any | null } | null, binder?: Array<(
    { __typename?: 'SOSTextfragmentImpl' }
    & SosTextfragmentFragment
  ) | null> | null, category?: Array<(
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTaxonomy_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTaxonomy_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTaxonomy_SosLocationImpl_Fragment
  ) | null> | null, donationCertificate?: Array<(
    { __typename?: 'SOSDonationCertificateImpl' }
    & SosDonationCertificateFragment
  ) | null> | null, landingPageLink?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmLinkable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmLinkable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmLinkable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmLinkable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmLinkable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmLinkable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmLinkable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmLinkable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmLinkable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmLinkable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmLinkable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLinkableImpl' }
    & CmLinkable_CmLinkableImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmLinkable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmLinkable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmLinkable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmLinkable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmLinkable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmLinkable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmLinkable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmLinkable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmLinkable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmLinkable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmLinkable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmLinkable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmLinkable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmLinkable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmLinkable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmLinkable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmLinkable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmLinkable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmLinkable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmLinkable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmLinkable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmLinkable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmLinkable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmLinkable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmLinkable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmLinkable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmLinkable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmLinkable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmLinkable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmLinkable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmLinkable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmLinkable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmLinkable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmLinkable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmLinkable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmLinkable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmLinkable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmLinkable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmLinkable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmLinkable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmLinkable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmLinkable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmLinkable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmLinkable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmLinkable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmLinkable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmLinkable_ViewTypeHeroCollection_Fragment
  ) | null> | null, related?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasableCommon_CmArticleImpl_Fragment
    & CmTeasableTeaserTarget_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasableCommon_CmAudioImpl_Fragment
    & CmTeasableTeaserTarget_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasableCommon_CmChannelImpl_Fragment
    & CmTeasableTeaserTarget_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl', items?: Array<(
      { __typename?: 'CMArticleImpl' }
      & CmTeasableCommon_CmArticleImpl_Fragment
      & CmTeasableTeaserTarget_CmArticleImpl_Fragment
    ) | (
      { __typename?: 'CMAudioImpl' }
      & CmTeasableCommon_CmAudioImpl_Fragment
      & CmTeasableTeaserTarget_CmAudioImpl_Fragment
    ) | (
      { __typename?: 'CMChannelImpl' }
      & CmTeasableCommon_CmChannelImpl_Fragment
      & CmTeasableTeaserTarget_CmChannelImpl_Fragment
    ) | (
      { __typename?: 'CMCollectionImpl' }
      & CmTeasableCommon_CmCollectionImpl_Fragment
      & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    ) | (
      { __typename?: 'CMDownloadImpl' }
      & CmTeasableCommon_CmDownloadImpl_Fragment
      & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    ) | (
      { __typename?: 'CMDynamicListImpl' }
      & CmTeasableCommon_CmDynamicListImpl_Fragment
      & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    ) | (
      { __typename?: 'CMExternalLinkImpl' }
      & CmTeasableCommon_CmExternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    ) | (
      { __typename?: 'CMGalleryImpl' }
      & CmTeasableCommon_CmGalleryImpl_Fragment
      & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    ) | (
      { __typename?: 'CMHTMLImpl' }
      & CmTeasableCommon_CmhtmlImpl_Fragment
      & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    ) | (
      { __typename?: 'CMImageMapImpl' }
      & CmTeasableCommon_CmImageMapImpl_Fragment
      & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
    ) | (
      { __typename?: 'CMInteractiveImpl' }
      & CmTeasableCommon_CmInteractiveImpl_Fragment
      & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
    ) | { __typename?: 'CMLinkableImpl' } | (
      { __typename?: 'CMLocTaxonomyImpl' }
      & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMMediaImpl' }
      & CmTeasableCommon_CmMediaImpl_Fragment
      & CmTeasableTeaserTarget_CmMediaImpl_Fragment
    ) | (
      { __typename?: 'CMNavigationImpl' }
      & CmTeasableCommon_CmNavigationImpl_Fragment
      & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
    ) | (
      { __typename?: 'CMPersonImpl' }
      & CmTeasableCommon_CmPersonImpl_Fragment
      & CmTeasableTeaserTarget_CmPersonImpl_Fragment
    ) | (
      { __typename?: 'CMPictureImpl' }
      & CmTeasableCommon_CmPictureImpl_Fragment
      & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    ) | (
      { __typename?: 'CMPlaceholderImpl' }
      & CmTeasableCommon_CmPlaceholderImpl_Fragment
      & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
    ) | (
      { __typename?: 'CMProductImpl' }
      & CmTeasableCommon_CmProductImpl_Fragment
      & CmTeasableTeaserTarget_CmProductImpl_Fragment
    ) | (
      { __typename?: 'CMQueryListImpl' }
      & CmTeasableCommon_CmQueryListImpl_Fragment
      & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    ) | (
      { __typename?: 'CMSelectionRulesImpl' }
      & CmTeasableCommon_CmSelectionRulesImpl_Fragment
      & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    ) | (
      { __typename?: 'CMSpinnerImpl' }
      & CmTeasableCommon_CmSpinnerImpl_Fragment
      & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
    ) | (
      { __typename?: 'CMTaxonomyImpl' }
      & CmTeasableCommon_CmTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMTeasableImpl' }
      & CmTeasableCommon_CmTeasableImpl_Fragment
      & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
    ) | (
      { __typename?: 'CMTeaserImpl' }
      & CmTeasableCommon_CmTeaserImpl_Fragment
      & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
    ) | (
      { __typename?: 'CMVideoImpl' }
      & CmTeasableCommon_CmVideoImpl_Fragment
      & CmTeasableTeaserTarget_CmVideoImpl_Fragment
    ) | (
      { __typename?: 'CMVisualImpl' }
      & CmTeasableCommon_CmVisualImpl_Fragment
      & CmTeasableTeaserTarget_CmVisualImpl_Fragment
    ) | (
      { __typename?: 'FormEditorImpl' }
      & CmTeasableCommon_FormEditorImpl_Fragment
      & CmTeasableTeaserTarget_FormEditorImpl_Fragment
    ) | (
      { __typename?: 'SOSAmountIncreaseFormImpl' }
      & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
      & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
    ) | (
      { __typename?: 'SOSAuthorImpl' }
      & CmTeasableCommon_SosAuthorImpl_Fragment
      & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
    ) | (
      { __typename?: 'SOSChartImpl' }
      & CmTeasableCommon_SosChartImpl_Fragment
      & CmTeasableTeaserTarget_SosChartImpl_Fragment
    ) | (
      { __typename?: 'SOSContactImpl' }
      & CmTeasableCommon_SosContactImpl_Fragment
      & CmTeasableTeaserTarget_SosContactImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCardImpl' }
      & CmTeasableCommon_SosDonationCardImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCertificateImpl' }
      & CmTeasableCommon_SosDonationCertificateImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationFormImpl' }
      & CmTeasableCommon_SosDonationFormImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProductImpl', price?: string | null, recommendation?: boolean | null, new?: boolean | null, category?: Array<(
        { __typename?: 'CMLocTaxonomyImpl' }
        & CmTaxonomy_CmLocTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'CMTaxonomyImpl' }
        & CmTaxonomy_CmTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'SOSLocationImpl' }
        & CmTaxonomy_SosLocationImpl_Fragment
      ) | null> | null }
      & CmTeasableCommon_SosDonationProductImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProgressImpl' }
      & CmTeasableCommon_SosDonationProgressImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationToolImpl' }
      & CmTeasableCommon_SosDonationToolImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
    ) | (
      { __typename?: 'SOSEventImpl' }
      & CmTeasableCommon_SosEventImpl_Fragment
      & CmTeasableTeaserTarget_SosEventImpl_Fragment
    ) | (
      { __typename?: 'SOSFilterTeaserImpl' }
      & CmTeasableCommon_SosFilterTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSInternalLinkImpl' }
      & CmTeasableCommon_SosInternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
    ) | (
      { __typename?: 'SOSJobTeaserImpl' }
      & CmTeasableCommon_SosJobTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSLocationImpl' }
      & CmTeasableCommon_SosLocationImpl_Fragment
      & CmTeasableTeaserTarget_SosLocationImpl_Fragment
    ) | (
      { __typename?: 'SOSNewsImpl' }
      & CmTeasableCommon_SosNewsImpl_Fragment
      & CmTeasableTeaserTarget_SosNewsImpl_Fragment
    ) | (
      { __typename?: 'SOSNotificationImpl' }
      & CmTeasableCommon_SosNotificationImpl_Fragment
      & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
    ) | (
      { __typename?: 'SOSOfferImpl' }
      & CmTeasableCommon_SosOfferImpl_Fragment
      & CmTeasableTeaserTarget_SosOfferImpl_Fragment
    ) | (
      { __typename?: 'SOSOrderFormImpl' }
      & CmTeasableCommon_SosOrderFormImpl_Fragment
      & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
    ) | (
      { __typename?: 'SOSOrganisationImpl' }
      & CmTeasableCommon_SosOrganisationImpl_Fragment
      & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
    ) | (
      { __typename?: 'SOSOverlayImpl' }
      & CmTeasableCommon_SosOverlayImpl_Fragment
      & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
    ) | (
      { __typename?: 'SOSPressreleaseImpl' }
      & CmTeasableCommon_SosPressreleaseImpl_Fragment
      & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
    ) | (
      { __typename?: 'SOSPublicationImpl' }
      & CmTeasableCommon_SosPublicationImpl_Fragment
      & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
    ) | (
      { __typename?: 'SOSRedirectPageImpl' }
      & CmTeasableCommon_SosRedirectPageImpl_Fragment
      & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicCategoryImpl' }
      & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicImpl' }
      & CmTeasableCommon_SosSpecialTopicImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
    ) | (
      { __typename?: 'SOSTeaserImpl' }
      & CmTeasableCommon_SosTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSTextfragmentImpl' }
      & CmTeasableCommon_SosTextfragmentImpl_Fragment
      & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    ) | (
      { __typename?: 'SOSTooltipImpl' }
      & CmTeasableCommon_SosTooltipImpl_Fragment
      & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
    ) | (
      { __typename?: 'SOSWimmelbildImpl' }
      & CmTeasableCommon_SosWimmelbildImpl_Fragment
      & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
    ) | (
      { __typename?: 'ViewTypeHeroCollection' }
      & CmTeasableCommon_ViewTypeHeroCollection_Fragment
      & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    ) | null> | null }
    & CmTeasableCommon_CmCollectionImpl_Fragment
    & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasableCommon_CmDownloadImpl_Fragment
    & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl', items?: Array<(
      { __typename?: 'CMArticleImpl' }
      & CmTeasableCommon_CmArticleImpl_Fragment
      & CmTeasableTeaserTarget_CmArticleImpl_Fragment
    ) | (
      { __typename?: 'CMAudioImpl' }
      & CmTeasableCommon_CmAudioImpl_Fragment
      & CmTeasableTeaserTarget_CmAudioImpl_Fragment
    ) | (
      { __typename?: 'CMChannelImpl' }
      & CmTeasableCommon_CmChannelImpl_Fragment
      & CmTeasableTeaserTarget_CmChannelImpl_Fragment
    ) | (
      { __typename?: 'CMCollectionImpl' }
      & CmTeasableCommon_CmCollectionImpl_Fragment
      & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    ) | (
      { __typename?: 'CMDownloadImpl' }
      & CmTeasableCommon_CmDownloadImpl_Fragment
      & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    ) | (
      { __typename?: 'CMDynamicListImpl' }
      & CmTeasableCommon_CmDynamicListImpl_Fragment
      & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    ) | (
      { __typename?: 'CMExternalLinkImpl' }
      & CmTeasableCommon_CmExternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    ) | (
      { __typename?: 'CMGalleryImpl' }
      & CmTeasableCommon_CmGalleryImpl_Fragment
      & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    ) | (
      { __typename?: 'CMHTMLImpl' }
      & CmTeasableCommon_CmhtmlImpl_Fragment
      & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    ) | (
      { __typename?: 'CMImageMapImpl' }
      & CmTeasableCommon_CmImageMapImpl_Fragment
      & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
    ) | (
      { __typename?: 'CMInteractiveImpl' }
      & CmTeasableCommon_CmInteractiveImpl_Fragment
      & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
    ) | { __typename?: 'CMLinkableImpl' } | (
      { __typename?: 'CMLocTaxonomyImpl' }
      & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMMediaImpl' }
      & CmTeasableCommon_CmMediaImpl_Fragment
      & CmTeasableTeaserTarget_CmMediaImpl_Fragment
    ) | (
      { __typename?: 'CMNavigationImpl' }
      & CmTeasableCommon_CmNavigationImpl_Fragment
      & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
    ) | (
      { __typename?: 'CMPersonImpl' }
      & CmTeasableCommon_CmPersonImpl_Fragment
      & CmTeasableTeaserTarget_CmPersonImpl_Fragment
    ) | (
      { __typename?: 'CMPictureImpl' }
      & CmTeasableCommon_CmPictureImpl_Fragment
      & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    ) | (
      { __typename?: 'CMPlaceholderImpl' }
      & CmTeasableCommon_CmPlaceholderImpl_Fragment
      & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
    ) | (
      { __typename?: 'CMProductImpl' }
      & CmTeasableCommon_CmProductImpl_Fragment
      & CmTeasableTeaserTarget_CmProductImpl_Fragment
    ) | (
      { __typename?: 'CMQueryListImpl' }
      & CmTeasableCommon_CmQueryListImpl_Fragment
      & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    ) | (
      { __typename?: 'CMSelectionRulesImpl' }
      & CmTeasableCommon_CmSelectionRulesImpl_Fragment
      & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    ) | (
      { __typename?: 'CMSpinnerImpl' }
      & CmTeasableCommon_CmSpinnerImpl_Fragment
      & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
    ) | (
      { __typename?: 'CMTaxonomyImpl' }
      & CmTeasableCommon_CmTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMTeasableImpl' }
      & CmTeasableCommon_CmTeasableImpl_Fragment
      & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
    ) | (
      { __typename?: 'CMTeaserImpl' }
      & CmTeasableCommon_CmTeaserImpl_Fragment
      & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
    ) | (
      { __typename?: 'CMVideoImpl' }
      & CmTeasableCommon_CmVideoImpl_Fragment
      & CmTeasableTeaserTarget_CmVideoImpl_Fragment
    ) | (
      { __typename?: 'CMVisualImpl' }
      & CmTeasableCommon_CmVisualImpl_Fragment
      & CmTeasableTeaserTarget_CmVisualImpl_Fragment
    ) | (
      { __typename?: 'FormEditorImpl' }
      & CmTeasableCommon_FormEditorImpl_Fragment
      & CmTeasableTeaserTarget_FormEditorImpl_Fragment
    ) | (
      { __typename?: 'SOSAmountIncreaseFormImpl' }
      & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
      & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
    ) | (
      { __typename?: 'SOSAuthorImpl' }
      & CmTeasableCommon_SosAuthorImpl_Fragment
      & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
    ) | (
      { __typename?: 'SOSChartImpl' }
      & CmTeasableCommon_SosChartImpl_Fragment
      & CmTeasableTeaserTarget_SosChartImpl_Fragment
    ) | (
      { __typename?: 'SOSContactImpl' }
      & CmTeasableCommon_SosContactImpl_Fragment
      & CmTeasableTeaserTarget_SosContactImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCardImpl' }
      & CmTeasableCommon_SosDonationCardImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCertificateImpl' }
      & CmTeasableCommon_SosDonationCertificateImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationFormImpl' }
      & CmTeasableCommon_SosDonationFormImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProductImpl', price?: string | null, recommendation?: boolean | null, new?: boolean | null, category?: Array<(
        { __typename?: 'CMLocTaxonomyImpl' }
        & CmTaxonomy_CmLocTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'CMTaxonomyImpl' }
        & CmTaxonomy_CmTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'SOSLocationImpl' }
        & CmTaxonomy_SosLocationImpl_Fragment
      ) | null> | null }
      & CmTeasableCommon_SosDonationProductImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProgressImpl' }
      & CmTeasableCommon_SosDonationProgressImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationToolImpl' }
      & CmTeasableCommon_SosDonationToolImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
    ) | (
      { __typename?: 'SOSEventImpl' }
      & CmTeasableCommon_SosEventImpl_Fragment
      & CmTeasableTeaserTarget_SosEventImpl_Fragment
    ) | (
      { __typename?: 'SOSFilterTeaserImpl' }
      & CmTeasableCommon_SosFilterTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSInternalLinkImpl' }
      & CmTeasableCommon_SosInternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
    ) | (
      { __typename?: 'SOSJobTeaserImpl' }
      & CmTeasableCommon_SosJobTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSLocationImpl' }
      & CmTeasableCommon_SosLocationImpl_Fragment
      & CmTeasableTeaserTarget_SosLocationImpl_Fragment
    ) | (
      { __typename?: 'SOSNewsImpl' }
      & CmTeasableCommon_SosNewsImpl_Fragment
      & CmTeasableTeaserTarget_SosNewsImpl_Fragment
    ) | (
      { __typename?: 'SOSNotificationImpl' }
      & CmTeasableCommon_SosNotificationImpl_Fragment
      & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
    ) | (
      { __typename?: 'SOSOfferImpl' }
      & CmTeasableCommon_SosOfferImpl_Fragment
      & CmTeasableTeaserTarget_SosOfferImpl_Fragment
    ) | (
      { __typename?: 'SOSOrderFormImpl' }
      & CmTeasableCommon_SosOrderFormImpl_Fragment
      & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
    ) | (
      { __typename?: 'SOSOrganisationImpl' }
      & CmTeasableCommon_SosOrganisationImpl_Fragment
      & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
    ) | (
      { __typename?: 'SOSOverlayImpl' }
      & CmTeasableCommon_SosOverlayImpl_Fragment
      & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
    ) | (
      { __typename?: 'SOSPressreleaseImpl' }
      & CmTeasableCommon_SosPressreleaseImpl_Fragment
      & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
    ) | (
      { __typename?: 'SOSPublicationImpl' }
      & CmTeasableCommon_SosPublicationImpl_Fragment
      & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
    ) | (
      { __typename?: 'SOSRedirectPageImpl' }
      & CmTeasableCommon_SosRedirectPageImpl_Fragment
      & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicCategoryImpl' }
      & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicImpl' }
      & CmTeasableCommon_SosSpecialTopicImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
    ) | (
      { __typename?: 'SOSTeaserImpl' }
      & CmTeasableCommon_SosTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSTextfragmentImpl' }
      & CmTeasableCommon_SosTextfragmentImpl_Fragment
      & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    ) | (
      { __typename?: 'SOSTooltipImpl' }
      & CmTeasableCommon_SosTooltipImpl_Fragment
      & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
    ) | (
      { __typename?: 'SOSWimmelbildImpl' }
      & CmTeasableCommon_SosWimmelbildImpl_Fragment
      & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
    ) | (
      { __typename?: 'ViewTypeHeroCollection' }
      & CmTeasableCommon_ViewTypeHeroCollection_Fragment
      & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    ) | null> | null }
    & CmTeasableCommon_CmDynamicListImpl_Fragment
    & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasableCommon_CmExternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl', items?: Array<(
      { __typename?: 'CMArticleImpl' }
      & CmTeasableCommon_CmArticleImpl_Fragment
      & CmTeasableTeaserTarget_CmArticleImpl_Fragment
    ) | (
      { __typename?: 'CMAudioImpl' }
      & CmTeasableCommon_CmAudioImpl_Fragment
      & CmTeasableTeaserTarget_CmAudioImpl_Fragment
    ) | (
      { __typename?: 'CMChannelImpl' }
      & CmTeasableCommon_CmChannelImpl_Fragment
      & CmTeasableTeaserTarget_CmChannelImpl_Fragment
    ) | (
      { __typename?: 'CMCollectionImpl' }
      & CmTeasableCommon_CmCollectionImpl_Fragment
      & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    ) | (
      { __typename?: 'CMDownloadImpl' }
      & CmTeasableCommon_CmDownloadImpl_Fragment
      & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    ) | (
      { __typename?: 'CMDynamicListImpl' }
      & CmTeasableCommon_CmDynamicListImpl_Fragment
      & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    ) | (
      { __typename?: 'CMExternalLinkImpl' }
      & CmTeasableCommon_CmExternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    ) | (
      { __typename?: 'CMGalleryImpl' }
      & CmTeasableCommon_CmGalleryImpl_Fragment
      & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    ) | (
      { __typename?: 'CMHTMLImpl' }
      & CmTeasableCommon_CmhtmlImpl_Fragment
      & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    ) | (
      { __typename?: 'CMImageMapImpl' }
      & CmTeasableCommon_CmImageMapImpl_Fragment
      & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
    ) | (
      { __typename?: 'CMInteractiveImpl' }
      & CmTeasableCommon_CmInteractiveImpl_Fragment
      & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
    ) | { __typename?: 'CMLinkableImpl' } | (
      { __typename?: 'CMLocTaxonomyImpl' }
      & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMMediaImpl' }
      & CmTeasableCommon_CmMediaImpl_Fragment
      & CmTeasableTeaserTarget_CmMediaImpl_Fragment
    ) | (
      { __typename?: 'CMNavigationImpl' }
      & CmTeasableCommon_CmNavigationImpl_Fragment
      & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
    ) | (
      { __typename?: 'CMPersonImpl' }
      & CmTeasableCommon_CmPersonImpl_Fragment
      & CmTeasableTeaserTarget_CmPersonImpl_Fragment
    ) | (
      { __typename?: 'CMPictureImpl' }
      & CmTeasableCommon_CmPictureImpl_Fragment
      & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    ) | (
      { __typename?: 'CMPlaceholderImpl' }
      & CmTeasableCommon_CmPlaceholderImpl_Fragment
      & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
    ) | (
      { __typename?: 'CMProductImpl' }
      & CmTeasableCommon_CmProductImpl_Fragment
      & CmTeasableTeaserTarget_CmProductImpl_Fragment
    ) | (
      { __typename?: 'CMQueryListImpl' }
      & CmTeasableCommon_CmQueryListImpl_Fragment
      & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    ) | (
      { __typename?: 'CMSelectionRulesImpl' }
      & CmTeasableCommon_CmSelectionRulesImpl_Fragment
      & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    ) | (
      { __typename?: 'CMSpinnerImpl' }
      & CmTeasableCommon_CmSpinnerImpl_Fragment
      & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
    ) | (
      { __typename?: 'CMTaxonomyImpl' }
      & CmTeasableCommon_CmTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMTeasableImpl' }
      & CmTeasableCommon_CmTeasableImpl_Fragment
      & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
    ) | (
      { __typename?: 'CMTeaserImpl' }
      & CmTeasableCommon_CmTeaserImpl_Fragment
      & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
    ) | (
      { __typename?: 'CMVideoImpl' }
      & CmTeasableCommon_CmVideoImpl_Fragment
      & CmTeasableTeaserTarget_CmVideoImpl_Fragment
    ) | (
      { __typename?: 'CMVisualImpl' }
      & CmTeasableCommon_CmVisualImpl_Fragment
      & CmTeasableTeaserTarget_CmVisualImpl_Fragment
    ) | (
      { __typename?: 'FormEditorImpl' }
      & CmTeasableCommon_FormEditorImpl_Fragment
      & CmTeasableTeaserTarget_FormEditorImpl_Fragment
    ) | (
      { __typename?: 'SOSAmountIncreaseFormImpl' }
      & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
      & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
    ) | (
      { __typename?: 'SOSAuthorImpl' }
      & CmTeasableCommon_SosAuthorImpl_Fragment
      & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
    ) | (
      { __typename?: 'SOSChartImpl' }
      & CmTeasableCommon_SosChartImpl_Fragment
      & CmTeasableTeaserTarget_SosChartImpl_Fragment
    ) | (
      { __typename?: 'SOSContactImpl' }
      & CmTeasableCommon_SosContactImpl_Fragment
      & CmTeasableTeaserTarget_SosContactImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCardImpl' }
      & CmTeasableCommon_SosDonationCardImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCertificateImpl' }
      & CmTeasableCommon_SosDonationCertificateImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationFormImpl' }
      & CmTeasableCommon_SosDonationFormImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProductImpl', price?: string | null, recommendation?: boolean | null, new?: boolean | null, category?: Array<(
        { __typename?: 'CMLocTaxonomyImpl' }
        & CmTaxonomy_CmLocTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'CMTaxonomyImpl' }
        & CmTaxonomy_CmTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'SOSLocationImpl' }
        & CmTaxonomy_SosLocationImpl_Fragment
      ) | null> | null }
      & CmTeasableCommon_SosDonationProductImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProgressImpl' }
      & CmTeasableCommon_SosDonationProgressImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationToolImpl' }
      & CmTeasableCommon_SosDonationToolImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
    ) | (
      { __typename?: 'SOSEventImpl' }
      & CmTeasableCommon_SosEventImpl_Fragment
      & CmTeasableTeaserTarget_SosEventImpl_Fragment
    ) | (
      { __typename?: 'SOSFilterTeaserImpl' }
      & CmTeasableCommon_SosFilterTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSInternalLinkImpl' }
      & CmTeasableCommon_SosInternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
    ) | (
      { __typename?: 'SOSJobTeaserImpl' }
      & CmTeasableCommon_SosJobTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSLocationImpl' }
      & CmTeasableCommon_SosLocationImpl_Fragment
      & CmTeasableTeaserTarget_SosLocationImpl_Fragment
    ) | (
      { __typename?: 'SOSNewsImpl' }
      & CmTeasableCommon_SosNewsImpl_Fragment
      & CmTeasableTeaserTarget_SosNewsImpl_Fragment
    ) | (
      { __typename?: 'SOSNotificationImpl' }
      & CmTeasableCommon_SosNotificationImpl_Fragment
      & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
    ) | (
      { __typename?: 'SOSOfferImpl' }
      & CmTeasableCommon_SosOfferImpl_Fragment
      & CmTeasableTeaserTarget_SosOfferImpl_Fragment
    ) | (
      { __typename?: 'SOSOrderFormImpl' }
      & CmTeasableCommon_SosOrderFormImpl_Fragment
      & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
    ) | (
      { __typename?: 'SOSOrganisationImpl' }
      & CmTeasableCommon_SosOrganisationImpl_Fragment
      & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
    ) | (
      { __typename?: 'SOSOverlayImpl' }
      & CmTeasableCommon_SosOverlayImpl_Fragment
      & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
    ) | (
      { __typename?: 'SOSPressreleaseImpl' }
      & CmTeasableCommon_SosPressreleaseImpl_Fragment
      & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
    ) | (
      { __typename?: 'SOSPublicationImpl' }
      & CmTeasableCommon_SosPublicationImpl_Fragment
      & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
    ) | (
      { __typename?: 'SOSRedirectPageImpl' }
      & CmTeasableCommon_SosRedirectPageImpl_Fragment
      & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicCategoryImpl' }
      & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicImpl' }
      & CmTeasableCommon_SosSpecialTopicImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
    ) | (
      { __typename?: 'SOSTeaserImpl' }
      & CmTeasableCommon_SosTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSTextfragmentImpl' }
      & CmTeasableCommon_SosTextfragmentImpl_Fragment
      & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    ) | (
      { __typename?: 'SOSTooltipImpl' }
      & CmTeasableCommon_SosTooltipImpl_Fragment
      & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
    ) | (
      { __typename?: 'SOSWimmelbildImpl' }
      & CmTeasableCommon_SosWimmelbildImpl_Fragment
      & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
    ) | (
      { __typename?: 'ViewTypeHeroCollection' }
      & CmTeasableCommon_ViewTypeHeroCollection_Fragment
      & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    ) | null> | null }
    & CmTeasableCommon_CmGalleryImpl_Fragment
    & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasableCommon_CmhtmlImpl_Fragment
    & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasableCommon_CmImageMapImpl_Fragment
    & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasableCommon_CmInteractiveImpl_Fragment
    & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasableCommon_CmMediaImpl_Fragment
    & CmTeasableTeaserTarget_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasableCommon_CmNavigationImpl_Fragment
    & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasableCommon_CmPersonImpl_Fragment
    & CmTeasableTeaserTarget_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasableCommon_CmPictureImpl_Fragment
    & CmTeasableTeaserTarget_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasableCommon_CmPlaceholderImpl_Fragment
    & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasableCommon_CmProductImpl_Fragment
    & CmTeasableTeaserTarget_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl', items?: Array<(
      { __typename?: 'CMArticleImpl' }
      & CmTeasableCommon_CmArticleImpl_Fragment
      & CmTeasableTeaserTarget_CmArticleImpl_Fragment
    ) | (
      { __typename?: 'CMAudioImpl' }
      & CmTeasableCommon_CmAudioImpl_Fragment
      & CmTeasableTeaserTarget_CmAudioImpl_Fragment
    ) | (
      { __typename?: 'CMChannelImpl' }
      & CmTeasableCommon_CmChannelImpl_Fragment
      & CmTeasableTeaserTarget_CmChannelImpl_Fragment
    ) | (
      { __typename?: 'CMCollectionImpl' }
      & CmTeasableCommon_CmCollectionImpl_Fragment
      & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    ) | (
      { __typename?: 'CMDownloadImpl' }
      & CmTeasableCommon_CmDownloadImpl_Fragment
      & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    ) | (
      { __typename?: 'CMDynamicListImpl' }
      & CmTeasableCommon_CmDynamicListImpl_Fragment
      & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    ) | (
      { __typename?: 'CMExternalLinkImpl' }
      & CmTeasableCommon_CmExternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    ) | (
      { __typename?: 'CMGalleryImpl' }
      & CmTeasableCommon_CmGalleryImpl_Fragment
      & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    ) | (
      { __typename?: 'CMHTMLImpl' }
      & CmTeasableCommon_CmhtmlImpl_Fragment
      & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    ) | (
      { __typename?: 'CMImageMapImpl' }
      & CmTeasableCommon_CmImageMapImpl_Fragment
      & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
    ) | (
      { __typename?: 'CMInteractiveImpl' }
      & CmTeasableCommon_CmInteractiveImpl_Fragment
      & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
    ) | { __typename?: 'CMLinkableImpl' } | (
      { __typename?: 'CMLocTaxonomyImpl' }
      & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMMediaImpl' }
      & CmTeasableCommon_CmMediaImpl_Fragment
      & CmTeasableTeaserTarget_CmMediaImpl_Fragment
    ) | (
      { __typename?: 'CMNavigationImpl' }
      & CmTeasableCommon_CmNavigationImpl_Fragment
      & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
    ) | (
      { __typename?: 'CMPersonImpl' }
      & CmTeasableCommon_CmPersonImpl_Fragment
      & CmTeasableTeaserTarget_CmPersonImpl_Fragment
    ) | (
      { __typename?: 'CMPictureImpl' }
      & CmTeasableCommon_CmPictureImpl_Fragment
      & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    ) | (
      { __typename?: 'CMPlaceholderImpl' }
      & CmTeasableCommon_CmPlaceholderImpl_Fragment
      & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
    ) | (
      { __typename?: 'CMProductImpl' }
      & CmTeasableCommon_CmProductImpl_Fragment
      & CmTeasableTeaserTarget_CmProductImpl_Fragment
    ) | (
      { __typename?: 'CMQueryListImpl' }
      & CmTeasableCommon_CmQueryListImpl_Fragment
      & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    ) | (
      { __typename?: 'CMSelectionRulesImpl' }
      & CmTeasableCommon_CmSelectionRulesImpl_Fragment
      & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    ) | (
      { __typename?: 'CMSpinnerImpl' }
      & CmTeasableCommon_CmSpinnerImpl_Fragment
      & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
    ) | (
      { __typename?: 'CMTaxonomyImpl' }
      & CmTeasableCommon_CmTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMTeasableImpl' }
      & CmTeasableCommon_CmTeasableImpl_Fragment
      & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
    ) | (
      { __typename?: 'CMTeaserImpl' }
      & CmTeasableCommon_CmTeaserImpl_Fragment
      & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
    ) | (
      { __typename?: 'CMVideoImpl' }
      & CmTeasableCommon_CmVideoImpl_Fragment
      & CmTeasableTeaserTarget_CmVideoImpl_Fragment
    ) | (
      { __typename?: 'CMVisualImpl' }
      & CmTeasableCommon_CmVisualImpl_Fragment
      & CmTeasableTeaserTarget_CmVisualImpl_Fragment
    ) | (
      { __typename?: 'FormEditorImpl' }
      & CmTeasableCommon_FormEditorImpl_Fragment
      & CmTeasableTeaserTarget_FormEditorImpl_Fragment
    ) | (
      { __typename?: 'SOSAmountIncreaseFormImpl' }
      & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
      & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
    ) | (
      { __typename?: 'SOSAuthorImpl' }
      & CmTeasableCommon_SosAuthorImpl_Fragment
      & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
    ) | (
      { __typename?: 'SOSChartImpl' }
      & CmTeasableCommon_SosChartImpl_Fragment
      & CmTeasableTeaserTarget_SosChartImpl_Fragment
    ) | (
      { __typename?: 'SOSContactImpl' }
      & CmTeasableCommon_SosContactImpl_Fragment
      & CmTeasableTeaserTarget_SosContactImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCardImpl' }
      & CmTeasableCommon_SosDonationCardImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCertificateImpl' }
      & CmTeasableCommon_SosDonationCertificateImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationFormImpl' }
      & CmTeasableCommon_SosDonationFormImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProductImpl', price?: string | null, recommendation?: boolean | null, new?: boolean | null, category?: Array<(
        { __typename?: 'CMLocTaxonomyImpl' }
        & CmTaxonomy_CmLocTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'CMTaxonomyImpl' }
        & CmTaxonomy_CmTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'SOSLocationImpl' }
        & CmTaxonomy_SosLocationImpl_Fragment
      ) | null> | null }
      & CmTeasableCommon_SosDonationProductImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProgressImpl' }
      & CmTeasableCommon_SosDonationProgressImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationToolImpl' }
      & CmTeasableCommon_SosDonationToolImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
    ) | (
      { __typename?: 'SOSEventImpl' }
      & CmTeasableCommon_SosEventImpl_Fragment
      & CmTeasableTeaserTarget_SosEventImpl_Fragment
    ) | (
      { __typename?: 'SOSFilterTeaserImpl' }
      & CmTeasableCommon_SosFilterTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSInternalLinkImpl' }
      & CmTeasableCommon_SosInternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
    ) | (
      { __typename?: 'SOSJobTeaserImpl' }
      & CmTeasableCommon_SosJobTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSLocationImpl' }
      & CmTeasableCommon_SosLocationImpl_Fragment
      & CmTeasableTeaserTarget_SosLocationImpl_Fragment
    ) | (
      { __typename?: 'SOSNewsImpl' }
      & CmTeasableCommon_SosNewsImpl_Fragment
      & CmTeasableTeaserTarget_SosNewsImpl_Fragment
    ) | (
      { __typename?: 'SOSNotificationImpl' }
      & CmTeasableCommon_SosNotificationImpl_Fragment
      & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
    ) | (
      { __typename?: 'SOSOfferImpl' }
      & CmTeasableCommon_SosOfferImpl_Fragment
      & CmTeasableTeaserTarget_SosOfferImpl_Fragment
    ) | (
      { __typename?: 'SOSOrderFormImpl' }
      & CmTeasableCommon_SosOrderFormImpl_Fragment
      & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
    ) | (
      { __typename?: 'SOSOrganisationImpl' }
      & CmTeasableCommon_SosOrganisationImpl_Fragment
      & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
    ) | (
      { __typename?: 'SOSOverlayImpl' }
      & CmTeasableCommon_SosOverlayImpl_Fragment
      & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
    ) | (
      { __typename?: 'SOSPressreleaseImpl' }
      & CmTeasableCommon_SosPressreleaseImpl_Fragment
      & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
    ) | (
      { __typename?: 'SOSPublicationImpl' }
      & CmTeasableCommon_SosPublicationImpl_Fragment
      & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
    ) | (
      { __typename?: 'SOSRedirectPageImpl' }
      & CmTeasableCommon_SosRedirectPageImpl_Fragment
      & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicCategoryImpl' }
      & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicImpl' }
      & CmTeasableCommon_SosSpecialTopicImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
    ) | (
      { __typename?: 'SOSTeaserImpl' }
      & CmTeasableCommon_SosTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSTextfragmentImpl' }
      & CmTeasableCommon_SosTextfragmentImpl_Fragment
      & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    ) | (
      { __typename?: 'SOSTooltipImpl' }
      & CmTeasableCommon_SosTooltipImpl_Fragment
      & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
    ) | (
      { __typename?: 'SOSWimmelbildImpl' }
      & CmTeasableCommon_SosWimmelbildImpl_Fragment
      & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
    ) | (
      { __typename?: 'ViewTypeHeroCollection' }
      & CmTeasableCommon_ViewTypeHeroCollection_Fragment
      & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    ) | null> | null }
    & CmTeasableCommon_CmQueryListImpl_Fragment
    & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl', items?: Array<(
      { __typename?: 'CMArticleImpl' }
      & CmTeasableCommon_CmArticleImpl_Fragment
      & CmTeasableTeaserTarget_CmArticleImpl_Fragment
    ) | (
      { __typename?: 'CMAudioImpl' }
      & CmTeasableCommon_CmAudioImpl_Fragment
      & CmTeasableTeaserTarget_CmAudioImpl_Fragment
    ) | (
      { __typename?: 'CMChannelImpl' }
      & CmTeasableCommon_CmChannelImpl_Fragment
      & CmTeasableTeaserTarget_CmChannelImpl_Fragment
    ) | (
      { __typename?: 'CMCollectionImpl' }
      & CmTeasableCommon_CmCollectionImpl_Fragment
      & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    ) | (
      { __typename?: 'CMDownloadImpl' }
      & CmTeasableCommon_CmDownloadImpl_Fragment
      & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    ) | (
      { __typename?: 'CMDynamicListImpl' }
      & CmTeasableCommon_CmDynamicListImpl_Fragment
      & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    ) | (
      { __typename?: 'CMExternalLinkImpl' }
      & CmTeasableCommon_CmExternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    ) | (
      { __typename?: 'CMGalleryImpl' }
      & CmTeasableCommon_CmGalleryImpl_Fragment
      & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    ) | (
      { __typename?: 'CMHTMLImpl' }
      & CmTeasableCommon_CmhtmlImpl_Fragment
      & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    ) | (
      { __typename?: 'CMImageMapImpl' }
      & CmTeasableCommon_CmImageMapImpl_Fragment
      & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
    ) | (
      { __typename?: 'CMInteractiveImpl' }
      & CmTeasableCommon_CmInteractiveImpl_Fragment
      & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
    ) | { __typename?: 'CMLinkableImpl' } | (
      { __typename?: 'CMLocTaxonomyImpl' }
      & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMMediaImpl' }
      & CmTeasableCommon_CmMediaImpl_Fragment
      & CmTeasableTeaserTarget_CmMediaImpl_Fragment
    ) | (
      { __typename?: 'CMNavigationImpl' }
      & CmTeasableCommon_CmNavigationImpl_Fragment
      & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
    ) | (
      { __typename?: 'CMPersonImpl' }
      & CmTeasableCommon_CmPersonImpl_Fragment
      & CmTeasableTeaserTarget_CmPersonImpl_Fragment
    ) | (
      { __typename?: 'CMPictureImpl' }
      & CmTeasableCommon_CmPictureImpl_Fragment
      & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    ) | (
      { __typename?: 'CMPlaceholderImpl' }
      & CmTeasableCommon_CmPlaceholderImpl_Fragment
      & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
    ) | (
      { __typename?: 'CMProductImpl' }
      & CmTeasableCommon_CmProductImpl_Fragment
      & CmTeasableTeaserTarget_CmProductImpl_Fragment
    ) | (
      { __typename?: 'CMQueryListImpl' }
      & CmTeasableCommon_CmQueryListImpl_Fragment
      & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    ) | (
      { __typename?: 'CMSelectionRulesImpl' }
      & CmTeasableCommon_CmSelectionRulesImpl_Fragment
      & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    ) | (
      { __typename?: 'CMSpinnerImpl' }
      & CmTeasableCommon_CmSpinnerImpl_Fragment
      & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
    ) | (
      { __typename?: 'CMTaxonomyImpl' }
      & CmTeasableCommon_CmTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMTeasableImpl' }
      & CmTeasableCommon_CmTeasableImpl_Fragment
      & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
    ) | (
      { __typename?: 'CMTeaserImpl' }
      & CmTeasableCommon_CmTeaserImpl_Fragment
      & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
    ) | (
      { __typename?: 'CMVideoImpl' }
      & CmTeasableCommon_CmVideoImpl_Fragment
      & CmTeasableTeaserTarget_CmVideoImpl_Fragment
    ) | (
      { __typename?: 'CMVisualImpl' }
      & CmTeasableCommon_CmVisualImpl_Fragment
      & CmTeasableTeaserTarget_CmVisualImpl_Fragment
    ) | (
      { __typename?: 'FormEditorImpl' }
      & CmTeasableCommon_FormEditorImpl_Fragment
      & CmTeasableTeaserTarget_FormEditorImpl_Fragment
    ) | (
      { __typename?: 'SOSAmountIncreaseFormImpl' }
      & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
      & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
    ) | (
      { __typename?: 'SOSAuthorImpl' }
      & CmTeasableCommon_SosAuthorImpl_Fragment
      & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
    ) | (
      { __typename?: 'SOSChartImpl' }
      & CmTeasableCommon_SosChartImpl_Fragment
      & CmTeasableTeaserTarget_SosChartImpl_Fragment
    ) | (
      { __typename?: 'SOSContactImpl' }
      & CmTeasableCommon_SosContactImpl_Fragment
      & CmTeasableTeaserTarget_SosContactImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCardImpl' }
      & CmTeasableCommon_SosDonationCardImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCertificateImpl' }
      & CmTeasableCommon_SosDonationCertificateImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationFormImpl' }
      & CmTeasableCommon_SosDonationFormImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProductImpl', price?: string | null, recommendation?: boolean | null, new?: boolean | null, category?: Array<(
        { __typename?: 'CMLocTaxonomyImpl' }
        & CmTaxonomy_CmLocTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'CMTaxonomyImpl' }
        & CmTaxonomy_CmTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'SOSLocationImpl' }
        & CmTaxonomy_SosLocationImpl_Fragment
      ) | null> | null }
      & CmTeasableCommon_SosDonationProductImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProgressImpl' }
      & CmTeasableCommon_SosDonationProgressImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationToolImpl' }
      & CmTeasableCommon_SosDonationToolImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
    ) | (
      { __typename?: 'SOSEventImpl' }
      & CmTeasableCommon_SosEventImpl_Fragment
      & CmTeasableTeaserTarget_SosEventImpl_Fragment
    ) | (
      { __typename?: 'SOSFilterTeaserImpl' }
      & CmTeasableCommon_SosFilterTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSInternalLinkImpl' }
      & CmTeasableCommon_SosInternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
    ) | (
      { __typename?: 'SOSJobTeaserImpl' }
      & CmTeasableCommon_SosJobTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSLocationImpl' }
      & CmTeasableCommon_SosLocationImpl_Fragment
      & CmTeasableTeaserTarget_SosLocationImpl_Fragment
    ) | (
      { __typename?: 'SOSNewsImpl' }
      & CmTeasableCommon_SosNewsImpl_Fragment
      & CmTeasableTeaserTarget_SosNewsImpl_Fragment
    ) | (
      { __typename?: 'SOSNotificationImpl' }
      & CmTeasableCommon_SosNotificationImpl_Fragment
      & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
    ) | (
      { __typename?: 'SOSOfferImpl' }
      & CmTeasableCommon_SosOfferImpl_Fragment
      & CmTeasableTeaserTarget_SosOfferImpl_Fragment
    ) | (
      { __typename?: 'SOSOrderFormImpl' }
      & CmTeasableCommon_SosOrderFormImpl_Fragment
      & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
    ) | (
      { __typename?: 'SOSOrganisationImpl' }
      & CmTeasableCommon_SosOrganisationImpl_Fragment
      & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
    ) | (
      { __typename?: 'SOSOverlayImpl' }
      & CmTeasableCommon_SosOverlayImpl_Fragment
      & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
    ) | (
      { __typename?: 'SOSPressreleaseImpl' }
      & CmTeasableCommon_SosPressreleaseImpl_Fragment
      & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
    ) | (
      { __typename?: 'SOSPublicationImpl' }
      & CmTeasableCommon_SosPublicationImpl_Fragment
      & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
    ) | (
      { __typename?: 'SOSRedirectPageImpl' }
      & CmTeasableCommon_SosRedirectPageImpl_Fragment
      & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicCategoryImpl' }
      & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicImpl' }
      & CmTeasableCommon_SosSpecialTopicImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
    ) | (
      { __typename?: 'SOSTeaserImpl' }
      & CmTeasableCommon_SosTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSTextfragmentImpl' }
      & CmTeasableCommon_SosTextfragmentImpl_Fragment
      & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    ) | (
      { __typename?: 'SOSTooltipImpl' }
      & CmTeasableCommon_SosTooltipImpl_Fragment
      & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
    ) | (
      { __typename?: 'SOSWimmelbildImpl' }
      & CmTeasableCommon_SosWimmelbildImpl_Fragment
      & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
    ) | (
      { __typename?: 'ViewTypeHeroCollection' }
      & CmTeasableCommon_ViewTypeHeroCollection_Fragment
      & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    ) | null> | null }
    & CmTeasableCommon_CmSelectionRulesImpl_Fragment
    & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasableCommon_CmSpinnerImpl_Fragment
    & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasableCommon_CmTaxonomyImpl_Fragment
    & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasableCommon_CmTeasableImpl_Fragment
    & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasableCommon_CmTeaserImpl_Fragment
    & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasableCommon_CmVideoImpl_Fragment
    & CmTeasableTeaserTarget_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasableCommon_CmVisualImpl_Fragment
    & CmTeasableTeaserTarget_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasableCommon_FormEditorImpl_Fragment
    & CmTeasableTeaserTarget_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
    & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasableCommon_SosAuthorImpl_Fragment
    & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasableCommon_SosChartImpl_Fragment
    & CmTeasableTeaserTarget_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasableCommon_SosContactImpl_Fragment
    & CmTeasableTeaserTarget_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasableCommon_SosDonationCardImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasableCommon_SosDonationCertificateImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasableCommon_SosDonationFormImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl', price?: string | null, recommendation?: boolean | null, new?: boolean | null, category?: Array<(
      { __typename?: 'CMLocTaxonomyImpl' }
      & CmTaxonomy_CmLocTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMTaxonomyImpl' }
      & CmTaxonomy_CmTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'SOSLocationImpl' }
      & CmTaxonomy_SosLocationImpl_Fragment
    ) | null> | null }
    & CmTeasableCommon_SosDonationProductImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasableCommon_SosDonationProgressImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasableCommon_SosDonationToolImpl_Fragment
    & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasableCommon_SosEventImpl_Fragment
    & CmTeasableTeaserTarget_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasableCommon_SosFilterTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasableCommon_SosInternalLinkImpl_Fragment
    & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasableCommon_SosJobTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasableCommon_SosLocationImpl_Fragment
    & CmTeasableTeaserTarget_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasableCommon_SosNewsImpl_Fragment
    & CmTeasableTeaserTarget_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasableCommon_SosNotificationImpl_Fragment
    & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasableCommon_SosOfferImpl_Fragment
    & CmTeasableTeaserTarget_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasableCommon_SosOrderFormImpl_Fragment
    & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasableCommon_SosOrganisationImpl_Fragment
    & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasableCommon_SosOverlayImpl_Fragment
    & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasableCommon_SosPressreleaseImpl_Fragment
    & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasableCommon_SosPublicationImpl_Fragment
    & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasableCommon_SosRedirectPageImpl_Fragment
    & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasableCommon_SosSpecialTopicImpl_Fragment
    & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasableCommon_SosTeaserImpl_Fragment
    & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasableCommon_SosTextfragmentImpl_Fragment
    & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasableCommon_SosTooltipImpl_Fragment
    & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasableCommon_SosWimmelbildImpl_Fragment
    & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection', items?: Array<(
      { __typename?: 'CMArticleImpl' }
      & CmTeasableCommon_CmArticleImpl_Fragment
      & CmTeasableTeaserTarget_CmArticleImpl_Fragment
    ) | (
      { __typename?: 'CMAudioImpl' }
      & CmTeasableCommon_CmAudioImpl_Fragment
      & CmTeasableTeaserTarget_CmAudioImpl_Fragment
    ) | (
      { __typename?: 'CMChannelImpl' }
      & CmTeasableCommon_CmChannelImpl_Fragment
      & CmTeasableTeaserTarget_CmChannelImpl_Fragment
    ) | (
      { __typename?: 'CMCollectionImpl' }
      & CmTeasableCommon_CmCollectionImpl_Fragment
      & CmTeasableTeaserTarget_CmCollectionImpl_Fragment
    ) | (
      { __typename?: 'CMDownloadImpl' }
      & CmTeasableCommon_CmDownloadImpl_Fragment
      & CmTeasableTeaserTarget_CmDownloadImpl_Fragment
    ) | (
      { __typename?: 'CMDynamicListImpl' }
      & CmTeasableCommon_CmDynamicListImpl_Fragment
      & CmTeasableTeaserTarget_CmDynamicListImpl_Fragment
    ) | (
      { __typename?: 'CMExternalLinkImpl' }
      & CmTeasableCommon_CmExternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_CmExternalLinkImpl_Fragment
    ) | (
      { __typename?: 'CMGalleryImpl' }
      & CmTeasableCommon_CmGalleryImpl_Fragment
      & CmTeasableTeaserTarget_CmGalleryImpl_Fragment
    ) | (
      { __typename?: 'CMHTMLImpl' }
      & CmTeasableCommon_CmhtmlImpl_Fragment
      & CmTeasableTeaserTarget_CmhtmlImpl_Fragment
    ) | (
      { __typename?: 'CMImageMapImpl' }
      & CmTeasableCommon_CmImageMapImpl_Fragment
      & CmTeasableTeaserTarget_CmImageMapImpl_Fragment
    ) | (
      { __typename?: 'CMInteractiveImpl' }
      & CmTeasableCommon_CmInteractiveImpl_Fragment
      & CmTeasableTeaserTarget_CmInteractiveImpl_Fragment
    ) | { __typename?: 'CMLinkableImpl' } | (
      { __typename?: 'CMLocTaxonomyImpl' }
      & CmTeasableCommon_CmLocTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmLocTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMMediaImpl' }
      & CmTeasableCommon_CmMediaImpl_Fragment
      & CmTeasableTeaserTarget_CmMediaImpl_Fragment
    ) | (
      { __typename?: 'CMNavigationImpl' }
      & CmTeasableCommon_CmNavigationImpl_Fragment
      & CmTeasableTeaserTarget_CmNavigationImpl_Fragment
    ) | (
      { __typename?: 'CMPersonImpl' }
      & CmTeasableCommon_CmPersonImpl_Fragment
      & CmTeasableTeaserTarget_CmPersonImpl_Fragment
    ) | (
      { __typename?: 'CMPictureImpl' }
      & CmTeasableCommon_CmPictureImpl_Fragment
      & CmTeasableTeaserTarget_CmPictureImpl_Fragment
    ) | (
      { __typename?: 'CMPlaceholderImpl' }
      & CmTeasableCommon_CmPlaceholderImpl_Fragment
      & CmTeasableTeaserTarget_CmPlaceholderImpl_Fragment
    ) | (
      { __typename?: 'CMProductImpl' }
      & CmTeasableCommon_CmProductImpl_Fragment
      & CmTeasableTeaserTarget_CmProductImpl_Fragment
    ) | (
      { __typename?: 'CMQueryListImpl' }
      & CmTeasableCommon_CmQueryListImpl_Fragment
      & CmTeasableTeaserTarget_CmQueryListImpl_Fragment
    ) | (
      { __typename?: 'CMSelectionRulesImpl' }
      & CmTeasableCommon_CmSelectionRulesImpl_Fragment
      & CmTeasableTeaserTarget_CmSelectionRulesImpl_Fragment
    ) | (
      { __typename?: 'CMSpinnerImpl' }
      & CmTeasableCommon_CmSpinnerImpl_Fragment
      & CmTeasableTeaserTarget_CmSpinnerImpl_Fragment
    ) | (
      { __typename?: 'CMTaxonomyImpl' }
      & CmTeasableCommon_CmTaxonomyImpl_Fragment
      & CmTeasableTeaserTarget_CmTaxonomyImpl_Fragment
    ) | (
      { __typename?: 'CMTeasableImpl' }
      & CmTeasableCommon_CmTeasableImpl_Fragment
      & CmTeasableTeaserTarget_CmTeasableImpl_Fragment
    ) | (
      { __typename?: 'CMTeaserImpl' }
      & CmTeasableCommon_CmTeaserImpl_Fragment
      & CmTeasableTeaserTarget_CmTeaserImpl_Fragment
    ) | (
      { __typename?: 'CMVideoImpl' }
      & CmTeasableCommon_CmVideoImpl_Fragment
      & CmTeasableTeaserTarget_CmVideoImpl_Fragment
    ) | (
      { __typename?: 'CMVisualImpl' }
      & CmTeasableCommon_CmVisualImpl_Fragment
      & CmTeasableTeaserTarget_CmVisualImpl_Fragment
    ) | (
      { __typename?: 'FormEditorImpl' }
      & CmTeasableCommon_FormEditorImpl_Fragment
      & CmTeasableTeaserTarget_FormEditorImpl_Fragment
    ) | (
      { __typename?: 'SOSAmountIncreaseFormImpl' }
      & CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment
      & CmTeasableTeaserTarget_SosAmountIncreaseFormImpl_Fragment
    ) | (
      { __typename?: 'SOSAuthorImpl' }
      & CmTeasableCommon_SosAuthorImpl_Fragment
      & CmTeasableTeaserTarget_SosAuthorImpl_Fragment
    ) | (
      { __typename?: 'SOSChartImpl' }
      & CmTeasableCommon_SosChartImpl_Fragment
      & CmTeasableTeaserTarget_SosChartImpl_Fragment
    ) | (
      { __typename?: 'SOSContactImpl' }
      & CmTeasableCommon_SosContactImpl_Fragment
      & CmTeasableTeaserTarget_SosContactImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCardImpl' }
      & CmTeasableCommon_SosDonationCardImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCardImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationCertificateImpl' }
      & CmTeasableCommon_SosDonationCertificateImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationCertificateImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationFormImpl' }
      & CmTeasableCommon_SosDonationFormImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationFormImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProductImpl', price?: string | null, recommendation?: boolean | null, new?: boolean | null, category?: Array<(
        { __typename?: 'CMLocTaxonomyImpl' }
        & CmTaxonomy_CmLocTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'CMTaxonomyImpl' }
        & CmTaxonomy_CmTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'SOSLocationImpl' }
        & CmTaxonomy_SosLocationImpl_Fragment
      ) | null> | null }
      & CmTeasableCommon_SosDonationProductImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationProgressImpl' }
      & CmTeasableCommon_SosDonationProgressImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationProgressImpl_Fragment
    ) | (
      { __typename?: 'SOSDonationToolImpl' }
      & CmTeasableCommon_SosDonationToolImpl_Fragment
      & CmTeasableTeaserTarget_SosDonationToolImpl_Fragment
    ) | (
      { __typename?: 'SOSEventImpl' }
      & CmTeasableCommon_SosEventImpl_Fragment
      & CmTeasableTeaserTarget_SosEventImpl_Fragment
    ) | (
      { __typename?: 'SOSFilterTeaserImpl' }
      & CmTeasableCommon_SosFilterTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosFilterTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSInternalLinkImpl' }
      & CmTeasableCommon_SosInternalLinkImpl_Fragment
      & CmTeasableTeaserTarget_SosInternalLinkImpl_Fragment
    ) | (
      { __typename?: 'SOSJobTeaserImpl' }
      & CmTeasableCommon_SosJobTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosJobTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSLocationImpl' }
      & CmTeasableCommon_SosLocationImpl_Fragment
      & CmTeasableTeaserTarget_SosLocationImpl_Fragment
    ) | (
      { __typename?: 'SOSNewsImpl' }
      & CmTeasableCommon_SosNewsImpl_Fragment
      & CmTeasableTeaserTarget_SosNewsImpl_Fragment
    ) | (
      { __typename?: 'SOSNotificationImpl' }
      & CmTeasableCommon_SosNotificationImpl_Fragment
      & CmTeasableTeaserTarget_SosNotificationImpl_Fragment
    ) | (
      { __typename?: 'SOSOfferImpl' }
      & CmTeasableCommon_SosOfferImpl_Fragment
      & CmTeasableTeaserTarget_SosOfferImpl_Fragment
    ) | (
      { __typename?: 'SOSOrderFormImpl' }
      & CmTeasableCommon_SosOrderFormImpl_Fragment
      & CmTeasableTeaserTarget_SosOrderFormImpl_Fragment
    ) | (
      { __typename?: 'SOSOrganisationImpl' }
      & CmTeasableCommon_SosOrganisationImpl_Fragment
      & CmTeasableTeaserTarget_SosOrganisationImpl_Fragment
    ) | (
      { __typename?: 'SOSOverlayImpl' }
      & CmTeasableCommon_SosOverlayImpl_Fragment
      & CmTeasableTeaserTarget_SosOverlayImpl_Fragment
    ) | (
      { __typename?: 'SOSPressreleaseImpl' }
      & CmTeasableCommon_SosPressreleaseImpl_Fragment
      & CmTeasableTeaserTarget_SosPressreleaseImpl_Fragment
    ) | (
      { __typename?: 'SOSPublicationImpl' }
      & CmTeasableCommon_SosPublicationImpl_Fragment
      & CmTeasableTeaserTarget_SosPublicationImpl_Fragment
    ) | (
      { __typename?: 'SOSRedirectPageImpl' }
      & CmTeasableCommon_SosRedirectPageImpl_Fragment
      & CmTeasableTeaserTarget_SosRedirectPageImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicCategoryImpl' }
      & CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicCategoryImpl_Fragment
    ) | (
      { __typename?: 'SOSSpecialTopicImpl' }
      & CmTeasableCommon_SosSpecialTopicImpl_Fragment
      & CmTeasableTeaserTarget_SosSpecialTopicImpl_Fragment
    ) | (
      { __typename?: 'SOSTeaserImpl' }
      & CmTeasableCommon_SosTeaserImpl_Fragment
      & CmTeasableTeaserTarget_SosTeaserImpl_Fragment
    ) | (
      { __typename?: 'SOSTextfragmentImpl' }
      & CmTeasableCommon_SosTextfragmentImpl_Fragment
      & CmTeasableTeaserTarget_SosTextfragmentImpl_Fragment
    ) | (
      { __typename?: 'SOSTooltipImpl' }
      & CmTeasableCommon_SosTooltipImpl_Fragment
      & CmTeasableTeaserTarget_SosTooltipImpl_Fragment
    ) | (
      { __typename?: 'SOSWimmelbildImpl' }
      & CmTeasableCommon_SosWimmelbildImpl_Fragment
      & CmTeasableTeaserTarget_SosWimmelbildImpl_Fragment
    ) | (
      { __typename?: 'ViewTypeHeroCollection' }
      & CmTeasableCommon_ViewTypeHeroCollection_Fragment
      & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
    ) | null> | null }
    & CmTeasableCommon_ViewTypeHeroCollection_Fragment
    & CmTeasableTeaserTarget_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_SosDonationProductImpl_Fragment
  & CmTeasableTeaserTarget_SosDonationProductImpl_Fragment
);

export const SosDonationProductFragmentDoc = gql`
    fragment SOSDonationProduct on SOSDonationProduct {
  ...CMTeasableCommon
  ...CMTeasableTeaserTarget
  details {
    textAsTree
  }
  price
  articleNumber
  unit
  recommendation
  new
  binder {
    ...SOSTextfragment
  }
  category {
    ...CMTaxonomy
  }
  donationCertificate {
    ...SOSDonationCertificate
  }
  landingPageLink {
    ...CMLinkable
  }
  related {
    ...CMTeasableCommon
    ...CMTeasableTeaserTarget
    ... on SOSDonationProduct {
      price
      recommendation
      new
      category {
        ...CMTaxonomy
      }
    }
    ... on CMCollection {
      items {
        ...CMTeasableCommon
        ...CMTeasableTeaserTarget
        ... on SOSDonationProduct {
          price
          recommendation
          new
          category {
            ...CMTaxonomy
          }
        }
      }
    }
  }
}
    ${CmTeasableCommonFragmentDoc}
${CmTeasableTeaserTargetFragmentDoc}
${SosTextfragmentFragmentDoc}
${CmTaxonomyFragmentDoc}
${SosDonationCertificateFragmentDoc}
${CmLinkableFragmentDoc}`;